import Nuclias from "../const/nuclias";

export const getUserAccessLevelI18n = (userType) => {
  let hashCode = '';

  switch (userType) {
    case Nuclias.userType.sp:
      hashCode = 'e1b3ec89ea';
      break;
    case Nuclias.userType.si:
      hashCode = '4b65444060';
      break;
    case Nuclias.userType.org:
      hashCode = 'c1ca926603';
      break;
    case Nuclias.userType.siteTag:
      hashCode = '3039a00fca';
      break;
    default:
      hashCode = 'a7d6475ec8';
  }

  return hashCode;
}

export const getUserPrivilegeI18n = (userPrivilege) => {
  let hashCode = '';

  switch (userPrivilege) {
    case Nuclias.userPrivilege.manager:
      hashCode = 'e3afed0047';
      break;
    case Nuclias.userPrivilege.editor:
      hashCode = '344a7f427f';
      break;
    case Nuclias.userPrivilege.monitor:
      hashCode = 'd2986ac8cb';
      break;
    default:
      hashCode = 'fb15c53f22';
  }

  return hashCode;
}